import { Offcanvas } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import NewLeadFormik from './NewLeadFormik';

interface OffNewLeadProps {
    show: boolean;
    setShow: (show: boolean) => void;
    fetchLeads: (force?: boolean) => Promise<void | null>;
}

const OffNewLead = ({ show, setShow, fetchLeads }: OffNewLeadProps) => {
    const { t } = useTranslation(['Leads']);

    const handleClose = () => {
        setShow(false);
    };

    return (
        <Offcanvas show={show} onHide={handleClose} placement="end">
            <Offcanvas.Header className="border-bottom" closeButton>
                <Offcanvas.Title>{t('newLead.title')}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="position-relative pb-0 d-flex flex-column px-0">
                <NewLeadFormik setShow={setShow} fetchLeads={fetchLeads} />
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default OffNewLead;
